<template>
	<el-tabs>
		<el-tab-pane > 
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div class="zidingyi_pd">
				<div v-for="(l,i) in value.shu"  style="position: relative;" class="zidingyi_sc">
					<div class="zidingyi_shanchu" @click.stop="Shanchu(i)"><i class="el-icon-circle-close"></i></div>					
					<Biaodan v-model="value.shu[i]" :ming='"gonggao"+i'></Biaodan>
				</div>
			</div>
			<el-button type="primary"  size="mini"  @click="Jia" style="margin-left: 20px;">+新增</el-button>
			
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<div class="big_box" v-if="value.yangshitu">
				<div class="tishi">图片</div>
				<el-input v-model="value.yangshitu.width" placeholder="px"> <template slot="prepend">宽度</template></el-input>
				<el-input v-model="value.yangshitu.height" placeholder="px"> <template slot="prepend">高度</template></el-input>
				<el-input v-model="value.yangshitu.text_align" placeholder="请输入内容"> <template slot="prepend">对齐</template></el-input>
				<el-input v-model="value.yangshitu.margin" placeholder="px"> <template slot="prepend">外边距</template></el-input>
				<el-input v-model="value.yangshitu.padding" placeholder="px"> <template slot="prepend">内边距</template></el-input>
			</div>
			<div class="big_box" v-if="value.yangshi">
				<div class="tishi">文字</div>
				<el-input v-model="value.yangshi.width" placeholder="px"> <template slot="prepend">宽度</template></el-input>
				<el-input v-model="value.yangshi.height" placeholder="px"> <template slot="prepend">高度</template></el-input>
				<el-input v-model="value.yangshi.text_align" placeholder="请输入内容"> <template slot="prepend">对齐</template></el-input>
				<el-input v-model="value.yangshi.margin" placeholder="px"> <template slot="prepend">外边距</template></el-input>
				<el-input v-model="value.yangshi.padding" placeholder="px"> <template slot="prepend">内边距</template></el-input>
				<el-input v-model="value.yangshi.color" placeholder="px"> <template slot="prepend">颜色</template></el-input>
			</div>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import Biaodan from '../Biaodan.vue'
	export default {
		name: 'gonggao_bianji',
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},
		components: {
			Biaodan
		},
		methods: {
			Jia() {
				this.value.shu.push({
					tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
					ming: '名称'
				})
			},
			Shanchu(e) {
				this.value.shu.splice(e, 1);
			}
		}
	}
</script>
<link rel="stylesheet" href="Yangshi.css">
